import React from 'react';
import { Navigate } from 'react-router-dom';
import { LazyPage } from '@hocs';
import { Routes } from '@enums';
import { jsx as _jsx } from "react/jsx-runtime";
var EventsPage = LazyPage('events', 'EventsPage');
var ErrorPage = LazyPage('error', 'ErrorPage');
var SectorsPage = LazyPage('sectors', 'SectorsPage');
var SectorPage = LazyPage('sector', 'SectorPage');
var PayPage = LazyPage('pay', 'PayPage');
var BasketPage = LazyPage('basket', 'BasketPage');
var ContactsPage = LazyPage('contacts', 'ContactsPage');
var HelpPage = LazyPage('help', 'HelpPage');
var MembershipPage = LazyPage('membership', 'MembershipPage');
var EventSelectPage = LazyPage('event-select', 'EventSelectPage');
var NotFoundPage = LazyPage('not-found', 'NotFoundPage');
var OrderPage = LazyPage('order-placing', 'OrderPlacingPage');
var PaymentSuccessPage = LazyPage('payment-success', 'PaymentSuccessPage');
var PaymentSuccessRemotePage = LazyPage('payment-success-remote', 'PaymentSuccessRemotePage');
var EmptyPage = LazyPage('empty', 'EmptyPage');
var appPublicRoutes = [{
  name: Routes.Main,
  path: Routes.Main,
  element: /*#__PURE__*/_jsx(Navigate, {
    to: Routes.Events,
    replace: true
  }),
  index: false
}, {
  name: Routes.Events,
  path: Routes.Events,
  element: /*#__PURE__*/_jsx(EventsPage, {}),
  index: false
}, {
  name: Routes.Membership,
  path: Routes.Membership,
  element: /*#__PURE__*/_jsx(MembershipPage, {}),
  index: false
}, {
  name: Routes.EventSelect,
  path: Routes.EventSelect,
  element: /*#__PURE__*/_jsx(EventSelectPage, {}),
  index: false
}, {
  name: Routes.Basket,
  path: Routes.Basket,
  element: /*#__PURE__*/_jsx(BasketPage, {}),
  index: false
}, {
  name: Routes.Sectors,
  path: Routes.Sectors,
  element: /*#__PURE__*/_jsx(SectorsPage, {}),
  index: false
}, {
  name: Routes.Sector,
  path: Routes.Sector,
  element: /*#__PURE__*/_jsx(SectorPage, {}),
  index: false
}, {
  name: Routes.Pay,
  path: Routes.Pay,
  element: /*#__PURE__*/_jsx(PayPage, {}),
  index: false
}, {
  name: Routes.Order,
  path: Routes.Order,
  element: /*#__PURE__*/_jsx(OrderPage, {}),
  index: false
}, {
  name: Routes.Contacts,
  path: Routes.Contacts,
  element: /*#__PURE__*/_jsx(ContactsPage, {}),
  index: false
}, {
  name: Routes.Help,
  path: Routes.Help,
  element: /*#__PURE__*/_jsx(HelpPage, {}),
  index: false
}, {
  name: Routes.PaymentSuccess,
  path: Routes.PaymentSuccess,
  element: /*#__PURE__*/_jsx(PaymentSuccessPage, {}),
  index: false
}, {
  name: Routes.PaymentSuccessRemote,
  path: Routes.PaymentSuccessRemote,
  element: /*#__PURE__*/_jsx(PaymentSuccessRemotePage, {}),
  index: false
}, {
  name: Routes.NotFound,
  path: Routes.NotFound,
  element: /*#__PURE__*/_jsx(NotFoundPage, {}),
  index: false,
  inline: true
}, {
  name: Routes.Empty,
  path: Routes.Empty,
  element: /*#__PURE__*/_jsx(EmptyPage, {}),
  index: false
}, {
  name: Routes.Error,
  path: Routes.Error,
  element: /*#__PURE__*/_jsx(ErrorPage, {}),
  index: false
}, {
  name: Routes.All,
  path: Routes.All,
  element: /*#__PURE__*/_jsx(Navigate, {
    to: Routes.NotFound,
    replace: true
  }),
  index: false
}];
export { appPublicRoutes };